import { defineStore } from 'pinia';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { useApiCredentialsStore } from './apiCredentials';
import { useSetupCredentialsStore } from './setupCredentials';

export const useAuthStore = defineStore('auth', {

    state() {
        const tokenFromCookie = Cookies.get('exampleJwt');
        return {
          token: tokenFromCookie || null,
          user: null
        };
    },

    actions: {

        setToken(token) {
            
            // Setto il token
            this.token = token;

            // Setto il cookie
            Cookies.set('exampleJwt', token, {
              secure: true,
              expires: 30,
              domain: import.meta.env.VITE_BASE_URL_COOKIES,
            });

            // Decodifico il token e setto l'utente
            this.user = jwtDecode(this.token);
        },

        removeToken() {
            this.token = null;
            Cookies.get('exampleJwt', { domain: import.meta.env.VITE_BASE_URL_COOKIES }) && Cookies.remove('exampleJwt', { domain: import.meta.env.VITE_BASE_URL_COOKIES, });
        },

        logout() {
            // Reset del token e altri dati di autenticazione
            this.removeToken();
            this.user = null;
            
            // Reset delle credenziali API
            const apiCredentialsStore = useApiCredentialsStore();
            apiCredentialsStore.clearCredentials();
            
            // Reset dello stato del setup
            const setupCredentialsStore = useSetupCredentialsStore();
            setupCredentialsStore.resetSetup();

            // Ricarica la pagina per resettare completamente lo stato
            window.location.reload();
        }
    },

    getters: {
        
        getToken: (state) => state.token,
        
        getAuthStatus: (state) => !!state.token,

        getUser: (state) => state.user,

        getUserType: (state) => state?.user ? state?.user?.user_type || null : null,

        getUserId: (state) => state?.user ? state?.user?.user_id || null : null,

    },

    persist: {
        key: 'auth',
        storage: window.localStorage,
        paths: ['user'],
        serialize: (state) => {
            return JSON.stringify({
                user: state.user || null
            });
        },
        deserialize: (storedState) => {
            const state = JSON.parse(storedState);
            return {
                user: state.user || null
            };
        }
    }
});